<script setup>
import { useI18n } from 'vue-i18n'
import { Button } from '@/components/ui/button'

const { locale } = useI18n()

const languages = [
  { code: 'es', label: 'ES' },
  { code: 'en', label: 'EN' },
  { code: 'el', label: 'EL' }
]

const toggleLanguage = () => {
  const currentIndex = languages.findIndex(l => l.code === locale.value)
  // Si no encuentra (ej: 'es-ES'), fallback a 0
  const idx = currentIndex === -1 ? 0 : currentIndex
  const nextIndex = (idx + 1) % languages.length
  locale.value = languages[nextIndex].code
}
</script>

<template>
  <Button variant="ghost" size="icon" @click="toggleLanguage" class="w-9 h-9 rounded-full bg-background/50 backdrop-blur-sm border border-border/50 hover:bg-accent">
     <span class="font-bold text-xs text-foreground">{{ locale.toUpperCase() }}</span>
     <span class="sr-only">Cambiar idioma</span>
  </Button>
</template>
